"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.77,14.65h-.1a.42.42,0,0,1-.31-.51A4.76,4.76,0,0,1,7.82,13a.43.43,0,0,1,.58-.18.44.44,0,0,1,.18.58,5.77,5.77,0,0,0-.4.94A.42.42,0,0,1,7.77,14.65Z",
    style: {
      fill: '#e4342a'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.28,12.07A.41.41,0,0,1,9,12a.43.43,0,0,1,0-.6A9.14,9.14,0,0,1,11,9.7a.42.42,0,0,1,.58.14.41.41,0,0,1-.14.58,8.47,8.47,0,0,0-1.83,1.51A.39.39,0,0,1,9.28,12.07Z",
    style: {
      fill: '#e4342a'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.89,9.65a.42.42,0,0,1-.39-.27.42.42,0,0,1,.24-.55,9.6,9.6,0,0,1,1.11-.38.42.42,0,1,1,.23.81c-.36.11-.71.23-1,.36A.45.45,0,0,1,12.89,9.65Z",
    style: {
      fill: '#e4342a'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.3,9.09A3.3,3.3,0,0,0,0,12.39c0,1.75,3,6.31,3.13,6.5A.19.19,0,0,0,3.3,19a.2.2,0,0,0,.17-.09c.13-.19,3.12-4.75,3.12-6.5A3.3,3.3,0,0,0,3.3,9.09Zm0,4.74a1.44,1.44,0,1,1,1.44-1.44A1.45,1.45,0,0,1,3.3,13.83Z",
    style: {
      fill: '#054966'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.24,5a2.77,2.77,0,0,0-2.76,2.76c0,1.46,2.51,5.28,2.61,5.44a.19.19,0,0,0,.15.08.16.16,0,0,0,.14-.08c.11-.16,2.62-4,2.62-5.44A2.77,2.77,0,0,0,21.24,5Zm0,4a1.21,1.21,0,1,1,1.21-1.21A1.21,1.21,0,0,1,21.24,9Z",
    style: {
      fill: '#054966'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.65,15.16a.48.48,0,0,1-.44-.28.49.49,0,0,1,.23-.64L17,9.78a.49.49,0,0,1,.64.24.47.47,0,0,1-.23.63L7.85,15.12A.51.51,0,0,1,7.65,15.16Z",
    style: {
      fill: '#054966'
    }
  }));
};

exports["default"] = _default;